import { proxy } from 'valtio'

const STORAGE_KEY = 'axflow_admin_dismissed_version'

interface VersionState {
  dismissedVersion: string | null
}

function loadPersistedState(): VersionState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return { dismissedVersion: raw ?? null }
  } catch {
    return { dismissedVersion: null }
  }
}

export const versionStore = proxy<VersionState>(loadPersistedState())

export function dismissVersion(version: string): void {
  versionStore.dismissedVersion = version
  try {
    localStorage.setItem(STORAGE_KEY, version)
  } catch {
    // localStorage unavailable (e.g. private browsing with storage blocked)
  }
}
